import fetch from 'services/request';
import { GetSupplierListParams, ICreateOrUpdateSupplierBody } from './constants';

const API_V1 = '/api/v1';
const SUPPLIER_BASE_URL = API_V1 + '/supplier';

const api = {
  supplier: {
    getList: (params: GetSupplierListParams) =>
      fetch({
        method: 'get',
        url: `${SUPPLIER_BASE_URL}/list`,
        params,
      }),
    createOrUpdate: (data: ICreateOrUpdateSupplierBody) =>
      fetch({
        method: 'post',
        url: `${SUPPLIER_BASE_URL}/add-or-update`,
        body: data,
      }),
    getDetail: (supplierId: string) =>
      fetch({
        method: 'get',
        url: `${SUPPLIER_BASE_URL}/detail/${supplierId}`,
      }),
    delete: (supplierId: string) =>
      fetch({
        method: 'post',
        url: `${SUPPLIER_BASE_URL}/delete/${supplierId}`,
      }),
  },
};

export default api;
